<template>
    <div class="row" v-if="! showAddRecord && records && records.length > 0">
        <div class="col-lg-12">
            <div class="card shadow">
                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="records"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width="10%">Qualification</th>
                            <th width="20%">Licensing Body</th>
                            <th width="10%">Start Date</th>
                            <th width="10%">End Date</th>
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ index+1}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.qualification }}
                        </td>
                        <td>
                            {{ row.licensing_body }}
                        </td>
                        <td>
                            {{row.start_date | getDateFormat}}
                        </td>
                        <td>
                            {{row.end_date | getDateFormat}}
                        </td>
                        <td>
                            <base-button
                                type="danger" size="sm"
                                @click="$emit('deleteQualRecord', row.id)"
                            >
                                <i class="fa fa-trash"></i> Remove
                            </base-button>
                        </td>

                        </template>

                    </base-table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'QualificationRecords',
        props: ["records", "showAddRecord"],
        filters: {
            getDateFormat(value) {
                return moment(value).format('MMM, YYYY');
            }
        }
    }
</script>